<template>
  <main class="redemption-success-page">
    <div class="success-shell">
      <h1 class="success-title">{{ $t("message.RedemptionSuccess").replace(/\s*!$/, "") }}</h1>
      <div class="success-card">
        <table class="success-table" :aria-label="$t('message.RedemptionSuccess')">
          <tbody>
            <tr class="summary-row"><th scope="row">{{ $t("message.TicketNo") }}</th><td>{{ TicketNo }}</td></tr>
            <tr><th scope="row">{{ $t("message.DateTime") }}</th><td class="success-date">{{ DateTime }}</td></tr>
            <tr><th scope="row">{{ $t("message.TimeIn") }}</th><td>{{ TimeIn }}</td></tr>
            <tr><th scope="row">{{ $t("message.Duration") }}</th><td>{{ Duration }}</td></tr>
            <tr><th scope="row">{{ $t("message.CarLicense") }}</th><td>{{ CarLicense }}</td></tr>
            <tr><th scope="row">{{ $t("message.VehicleName") }}</th><td>{{ VehicleName }}</td></tr>
            <tr><th scope="row">{{ $t("message.RateDetail") }}</th><td class="success-rate">{{ ($t("message.RateDetailLang") == "ENG" ? RateDetailENG : RateDetail).split("\r\n")[0] }}</td></tr>
            <tr class="summary-row"><th scope="row">{{ $t("message.Total") }}</th><td>{{ numberWithCommas(Total) }} {{ $t("message.Baht") }}</td></tr>
          </tbody>
        </table>
      </div>
      <v-btn class="back-button" rounded depressed @click="BackToMain()">{{ $t("message.BackToMain") }}</v-btn>
    </div>
  </main>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";
export default {
  name: "Redemption",

  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      AlertDialog: false,
      TypeAlert: null,
      MessageAlert: "",
      Rate: "",
      ResponseRedeem: [],

      TerminalID: null,
      DatetimeIn: "",
      MemberType: null,
      CarType: null,
      UserID: null,

      TicketNo: "",
      DateTime: "",
      TimeIn: "",
      Duration: "",
      CarLicense: "",
      VehicleName: "",
      RateCodeString: "",
      RateDetail: "",
      RateDetailENG: "",
      Total: "",

      projectID: localStorage.getItem("ProjectSiteID"),
    };
  },

  mounted() {
    let self = this;
    self.Rate = self.$route.params.ratecode;
    self.ResponseRedeem = self.$route.params.ResponseRedeem;
    self.BindingDataResponse();
  },

  methods: {
    BackToMain() {
      let self = this;
      self.ClearData();
      self.$router.push("/Main");
    },

    BindingDataResponse() {
      let self = this;
      if (self.ResponseRedeem != "" && self.ResponseRedeem != undefined) {
        if (self.ResponseRedeem.status != "Fail") {
          self.TerminalID = self.ResponseRedeem.terminalInId;
          self.DatetimeIn = self.ResponseRedeem.entryDateTime;
          self.MemberType = self.ResponseRedeem.memberTypeId;
          self.CarType = self.ResponseRedeem.vehicleTypeId;
          self.TicketNo = self.ResponseRedeem.ticketNo;
          const entryDate = new Date(self.ResponseRedeem.entryDateTime);
          self.DateTime = Number.isNaN(entryDate.getTime()) ? "" :
            `${String(entryDate.getDate()).padStart(2, "0")} ${entryDate.toLocaleDateString(self.$i18n.locale === "th" ? "th-TH" : "en-US", { month: "short" })} ${entryDate.getFullYear()}`;
          self.TimeIn =
            (self.ResponseRedeem.entryDateTime || "").split(" ").length > 0
              ? (self.ResponseRedeem.entryDateTime || "").split(" ")[1]
              : "";
          self.Duration =
            self.ResponseRedeem.parkHH +
            (self.$i18n.locale === "th" ? " ชั่วโมง " : " Hour ") +
            self.ResponseRedeem.parkMM +
            (self.$i18n.locale === "th" ? " นาที" : " Minute");
          self.CarLicense = self.ResponseRedeem.plateNo;
          self.VehicleName = self.ResponseRedeem.vehicleTypeName;
          self.RateCodeString = self.ResponseRedeem.rateCode;
          self.RateDetail = self.ResponseRedeem.rateDetailTH || "";
          self.RateDetailENG = self.ResponseRedeem.rateDetailEN || "";
          self.Total = self.ResponseRedeem.total;
          this.GetDataRateCode(
            self.ResponseRedeem.memberTypeId,
            self.ResponseRedeem.vehicleTypeId
          );
        }
      }
    },

    GetDataRateCode(membertype, vehicletype) {
      let self = this;
      let temp = {
        MemberType: membertype,
        VehicleType: vehicletype,
        projectID: self.projectID
      };
      axios
        .post(`${self.url}Redemption/GetDataRateCode`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.RateList = response.data.data;
          }
        })
        .catch(function (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    ClearData() {
      let self = this;
      self.TerminalID = null;
      self.DatetimeIn = "";
      self.MemberType = null;
      self.CarType = null;
      self.UserID = null;
      self.TicketNo = "";
      self.DateTime = "";
      self.TimeIn = "";
      self.Duration = "";
      self.CarLicense = "";
      self.VehicleName = "";
      self.RateCodeString = "";
      self.RateDetail = "";
      self.RateDetailENG = "";
      self.Total = "";
    },

    numberWithCommas(x) {
      return Number(x || 0).toLocaleString();
    },
  },
};
</script>
<style scoped>
.redemption-success-page {
  min-height: calc(100vh - 132px);
  background: #faf9f7;
  color: #262223;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif;
}
.success-shell, .success-shell * {
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
}
.success-shell {
  width: min(100% - 48px, 1364px);
  margin: 0 auto;
  padding: 120px 0 100px;
  text-align: center;
}
.success-title {
  margin: 0 0 68px;
  font-family: inherit;
  font-size: 36px;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: 0.02em;
}
.success-card {
  overflow: hidden;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 8px 8px rgba(38, 34, 35, 0.3);
}
.success-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 22px;
  line-height: 1.4;
}
.success-table tr { height: 46px; }
.success-table th,
.success-table td {
  padding: 7px 44px;
  border: 0;
  font-weight: 400;
}
.success-table th { width: 55%; text-align: left; }
.success-table td { text-align: center; overflow-wrap: anywhere; }
.success-table .summary-row {
  height: 52px;
  background: #262223;
  color: #ffffff;
}
.success-date { text-transform: uppercase; }
.success-rate { color: #d52d0a; }
.back-button.v-btn {
  min-width: 190px !important;
  height: 52px !important;
  margin-top: 70px;
  background: #262223 !important;
  color: #ffffff;
  font-family: inherit;
  font-size: 17px;
  font-weight: 400;
  letter-spacing: 0;
  text-transform: none;
  box-shadow: 0 6px 8px rgba(38, 34, 35, 0.3) !important;
}
.back-button:focus-visible { outline: 2px solid #262223; outline-offset: 5px; }
@media (max-width: 600px) {
  .success-shell { width: calc(100% - 32px); padding: 48px 0 64px; }
  .success-title { margin-bottom: 32px; font-size: 28px; }
  .success-table { font-size: 17px; }
  .success-table th { width: 42%; }
  .success-table th, .success-table td { padding: 12px 14px; }
  .back-button.v-btn { margin-top: 36px; }
}
</style>
